import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Lock } from 'lucide-react';

/**
 * Inline admin password verification dialog.
 * Props: showDialog, password, setPassword, verifying, handleVerify, handleClose
 */
const ExportPasswordDialog = ({ showDialog, password, setPassword, verifying, handleVerify, handleClose }) => {
  return (
    <Dialog open={showDialog} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock size={18} />
            Admin Verification Required
          </DialogTitle>
          <DialogDescription>
            Enter admin password to proceed with the download
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Admin Password</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleVerify()}
              placeholder="Enter admin password"
              autoFocus
              data-testid="admin-export-password"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>Cancel</Button>
          <Button onClick={handleVerify} disabled={verifying || !password.trim()} data-testid="verify-export-btn">
            {verifying ? 'Verifying...' : 'Verify & Download'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExportPasswordDialog;
